import * as SegmentTracking from '@hotjar/webapp/domains/common/tracking/segment';
import type { Site } from '@hotjar/site';
import { tagRecording } from './tools/hotjar';
import { extractSiteGroupingProps } from './utils';
import { validateEventData } from './validate-event-data';

export const help = (
  helpType: string | undefined,
  currentSite: Site,
  data?: SegmentTracking.EventProperties & SegmentTracking.CustomEventProperties,
): void => {
  const valid = validateEventData('Track.help', [helpType as string]);

  if (!valid) return;

  const trackingData = {
    ...data,
    ...extractSiteGroupingProps(currentSite),
    ...(helpType !== undefined && { help_type: helpType }),
  };

  tagRecording(`Help: ${helpType}`);
  SegmentTracking.track('Accessed Help', trackingData);
};
